import { Phone } from "lucide-react";
import { useShop } from "@/shop/ShopContext";

const FloatingCall = () => {
  const { config } = useShop();
  return (
    <a
      href={config.phone_href}
      data-testid="floating-phone-btn"
      className="fixed bottom-5 right-5 z-40 flex items-center gap-2.5 rounded-full bg-[#FF5500] py-3 pl-4 pr-5 font-display text-sm uppercase tracking-wider text-white shadow-[0_8px_30px_rgba(255,85,0,0.45)] transition-transform duration-300 hover:scale-105"
    >
      <span className="relative flex h-2.5 w-2.5">
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-white opacity-70" />
        <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-white" />
      </span>
      <Phone className="h-4 w-4" />
      {config.phone}
    </a>
  );
};

export default FloatingCall;
